// extracted by mini-css-extract-plugin
export default {"icon":"qH75dwiGPKB9iAQQSu4e"};